/*
 * Copyright (C) 2018 - 2026 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

const THOUSAND_SEPARATOR_REGEX = /\B(?=(\d{3})+(?!\d))/g;
const COMMA_REGEX = /,/g;

export const formatCurrency = (value = 0) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'LKR',
  }).format(value);
};

export const NumberFormat = (value = 0) => {
  return new Intl.NumberFormat('en-US').format(value);
};

export const formatWithThousandSeparator = (value) => {
  if (value === null || value === undefined || value === '') return '';
  return value.toString().replace(THOUSAND_SEPARATOR_REGEX, ',');
};

export const parseFormattedNumber = (value) => {
  if (!value) return '';
  return value.replace(COMMA_REGEX, '');
};
